// Minimal vanilla implementation of Bootstrap-like collapse toggles
// Listens for clicks on [data-bs-toggle="collapse"] and toggles target elements

(function () {
    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-bs-toggle="collapse"]');
        if (!trigger) return;
        e.preventDefault();

        var selector = trigger.getAttribute('data-bs-target') || trigger.getAttribute('href');
        if (!selector) return;

        // If href is something like '#id' keep it
        var target = document.querySelector(selector);
        if (!target) return;

        // Dispatch 'show.bs.collapse' before changing state
        var showEvent = new CustomEvent('show.bs.collapse', { cancelable: true, detail: { relatedTarget: trigger } });
        var proceed = target.dispatchEvent(showEvent);
        if (!proceed) return; // cancelled

        var isShown = target.classList.contains('show');
        if (isShown) {
            // hide
            target.classList.remove('show');
            try { trigger.setAttribute('aria-expanded', 'false'); } catch (err) {}
            target.dispatchEvent(new CustomEvent('hidden.bs.collapse', { detail: { relatedTarget: trigger } }));
        } else {
            // show
            target.classList.add('show');
            try { trigger.setAttribute('aria-expanded', 'true'); } catch (err) {}
            target.dispatchEvent(new CustomEvent('shown.bs.collapse', { detail: { relatedTarget: trigger } }));
        }
    }, false);

    // Expose a programmatic API similar to Bootstrap's minimal needs
    window.BSCollapse = {
        show: function (el) { if (!el) return; el.dispatchEvent(new CustomEvent('show.bs.collapse', { cancelable: true })); el.classList.add('show'); el.dispatchEvent(new CustomEvent('shown.bs.collapse')); },
        hide: function (el) { if (!el) return; el.dispatchEvent(new CustomEvent('hide.bs.collapse', { cancelable: true })); el.classList.remove('show'); el.dispatchEvent(new CustomEvent('hidden.bs.collapse')); },
        toggle: function (el) { if (!el) return; if (el.classList.contains('show')) this.hide(el); else this.show(el); }
    };
})();
